import type { WorldReadyProps } from '@client/utils/localeHelper';
import { MerchantSettings } from '@client/typings/Common';

import {
  ButtonLayout,
  ButtonShape,
  ButtonSize,
  ButtonColorType,
  SecondButtonType,
  ButtonTextType
} from '@components/Settings/types';

export const DEFAULT_MERCHANT_CHECKOUT_SETTINGS: MerchantSettings = Object.freeze({
  payment_method_paylater: true,
  payment_method_venmo: true,
  payment_method_apple_pay: true,
  show_business_name: false,
  show_business_logo: false,
  homepage_url: ''
});

export const DEFAULT_MERCHANT_STACKED_BUTTON_SETTINGS: MerchantSettings = Object.freeze({
  stacked_button_layout: ButtonLayout.Vertical,
  stacked_button_shape: ButtonShape.Rect,
  stacked_button_size: ButtonSize.Medium,
  stacked_button_color_type: ButtonColorType.Gold,
  stacked_button_second_button_type: SecondButtonType.PayPalRecommended,
  stacked_button_text_type: ButtonTextType.Checkout,
  stacked_button_custom_text: ''
});

export const DEFAULT_MERCHANT_SINGLE_BUTTON_SETTINGS: MerchantSettings = Object.freeze({
  single_button_color_type: ButtonColorType.Gold,
  single_button_shape: ButtonShape.Rect,
  single_button_size: ButtonSize.Medium,
  single_button_color_code: 'FFD140'
});

export const DEFAULT_MERCHANT_CART_BUTTON_SETTINGS: MerchantSettings = Object.freeze({
  cart_button_shape: ButtonShape.Rect,
  cart_button_size: ButtonSize.Medium,
  cart_button_color_type: ButtonColorType.Gold,
  cart_button_color_code: 'FFD140',
  auto_return_url: ''
});

export const DEFAULT_MERCHANT_SETTINGS: MerchantSettings = Object.freeze({
  ...DEFAULT_MERCHANT_CHECKOUT_SETTINGS,
  ...DEFAULT_MERCHANT_STACKED_BUTTON_SETTINGS,
  ...DEFAULT_MERCHANT_SINGLE_BUTTON_SETTINGS
});

const getInitialMerchantSettings = (
  worldReady: WorldReadyProps,
  merchantSettings: MerchantSettings | undefined,
  isSettingsEnabled?: boolean,
  isCartButtonSettingEnabled?: boolean
): MerchantSettings => {
  const defaultMerchantSettings: MerchantSettings = {
    ...(isSettingsEnabled ? DEFAULT_MERCHANT_SETTINGS : {}),
    ...(isCartButtonSettingEnabled ? DEFAULT_MERCHANT_CART_BUTTON_SETTINGS : {})
  };

  if (merchantSettings) {
    return {
      ...defaultMerchantSettings,
      ...merchantSettings
    };
  }

  return defaultMerchantSettings;
};

export default getInitialMerchantSettings;
